import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_TRADEMARK_TM_REGISTRATIONS_PAGE: IInventoryPage = {
	'route': '/research/trademark/tm-registrations',
	'title': 'TM Registrations',
	'uiReference': [
		'Selected registration date range',
		'Trademark status totals',
		'Registration period',
		'Browse weekly trademark activity',
		'Select a calendar week and jurisdiction to load filed and registered marks.',
		'Year',
		'Calendar week',
		'Date range',
		'Country',
		'Weekly registry',
		'Trademarks',
		'Filed',
		'Registered',
		'Ended',
		'Expired',
		'Filter results',
		'Refine results',
		'Filter displayed registrations',
		'Narrow the loaded week without making another request.',
		'Reset filters',
		'Trademark offices',
		'Choose the jurisdictions to display.',
		'Nice classes',
		'Limit results to relevant goods and services.',
		'Status',
		'Review filed, registered, ended, or expired marks.',
		'Legal notice: This is not legal advice. Each user remains responsible for verifying trademark information and determining whether a mark is safe to use.',
		'Loading...',
		'Sorry, there was an internal error. Please contact support.',
		'Rows per page',
		'Close trademark details',
		'Add to Watchlist',
		'Search Applicant',
		'View',
		'TM Name',
		'Applicant',
		'Nice Class',
		'Office',
		'filed',
		'registered',
		'Application',
		'Number',
		'Registration',
		'Enter a page number',
		'Go to page',
		'Page number'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/trademark-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/tm-registrations/tm-registrations.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/tm-registrations/tm-registrations.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-table/tm-table.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-table/tm-table.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-details/tm-detail.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-details/tm-detail.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-details/tm-detail.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-pagination/tm-pagination.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-pagination/tm-pagination.component.html'
	],
	'aliases': []
};
